import { defineMessages } from 'react-intl';

export default defineMessages({
    effectiveDate: {
        id: 'twia.quoteandbind.views.contact-details.policychange.PolicyChangeEffectiveDate',
        defaultMessage: 'Policy Change Effective Date',
    },
});
